import { EnovaOrganizationUnitLookupService } from './../proxy/organization-units/enova-organization-unit-lookup.service';
import { TicketKind, ticketKindOptions } from './../proxy/tickets/ticket-kind.enum';
import { ConfigStateService, downloadBlob, ListService, LocalizationService, PagedResultDto, PermissionService } from '@abp/ng.core';
import { Component, Inject, OnInit } from '@angular/core';
import { GetTicketListDto, TicketDto, TicketEducationKind, ticketEducationKindOptions, TicketsService, TicketStatus, ticketStatusOptions } from '@proxy/tickets';
import { NgbDateNativeAdapter, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { merge, Observable, OperatorFunction, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, map, switchMap } from 'rxjs/operators';
import { Confirmation, ConfirmationService, ToasterService } from '@abp/ng.theme.shared';
import { Constants, LookupConsts } from '../shared/Constants/Constants';
import { TenantUserLookupDto } from '@proxy/enova-users-lookup';
import { TenantDocumentLookupService } from '@proxy/tenant-documents';
import { TenantCourseLookupService } from '@proxy/tenant-courses';
import { DocumentApprovalDto, DocumentApprovalSettingsService } from '@proxy/documents-approval';
import { LookupDto, LookupRequestDto } from '@proxy/shared';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EnovaOrganizationUnitsService } from '@proxy/enova-organization-units';
import { Router } from '@angular/router';
import { UserRoleConsts } from '../shared/Constants/user-roles.constants';
import { BundlesLookupService } from '@proxy/bundles';
import { TestLookupService } from '@proxy/tests';
import { ROUTE_LIST_PROVIDERS, RouteListService } from '../shared/ExtendedListService/route-list.service';
import { SECONDARY_LIST } from '../shared/ExtendedListService/secondary-list.service';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss'],
  providers: [ROUTE_LIST_PROVIDERS, DatePipe,
    {
      provide: NgbDateAdapter, useClass: NgbDateNativeAdapter
    },
    {
      provide: SECONDARY_LIST, useClass: ListService
    }
  ],
})
export class TicketComponent implements OnInit {
  lookupMaxResultCount = LookupConsts.DEFAULT_MAX_RESULT_COUNT;

  task = {
    items: [], 
    totalCount: 0 
  } as PagedResultDto<TicketDto>;

  selectedUsers = {
    items: [],
    totalCount: 0
  } as PagedResultDto<TenantUserLookupDto>;

  filteredOrganizationUnits = {
    items: [],
    totalCount: 0
  } as PagedResultDto<LookupDto<string>>

  isModalOpen = false;
  isModalBusy = false;
  statusTypes =  ticketStatusOptions;
  ticketKinds = ticketKindOptions;
  ticketEducationKinds = ticketEducationKindOptions;
  filterForm: UntypedFormGroup;
  createUpdateTicketForm: UntypedFormGroup;
  tenantUsers$: Observable<TenantUserLookupDto[]>;
  activeTenantUsers$: Observable<TenantUserLookupDto[]>;
  selectedTicket = {} as TicketDto;
  DateTimeFormatConst = Constants.DATETIME;
  tenantUsersLookup: TenantUserLookupDto[] = [];
  isTicketEducationKindShown: boolean = false;
  isDocumentShown: boolean = null;
  isBundleShown: boolean = null;
  isTestShown: boolean = null;
  isDocumentShownForApproval: boolean = null;
  isTicketDocumentApprovalSelected: boolean = false;
  isTicketEdit: boolean = false;
  selectFromUsers: boolean = false;
  selectFromOrganizationUnit: boolean = false;
  onlyActive: boolean = true;

  responsibleUserForApproval: DocumentApprovalDto;
  currentUserId: string;

  today: Date = new Date();
  weekFromToday: Date = new Date();
  
  focusForTicketCourse$ = new Subject<string>();
  clickForTicketCourse$ = new Subject<string>();
  focusForTicketTenant$ = new Subject<string>();
  clickForTicketTenant$ = new Subject<string>();
  organizationUnitId;

  tenantFormatter = (tenant: TenantUserLookupDto) => tenant.userName;

  disabled = false;
  limitSelection = false;
  dropdownSettings: IDropdownSettings = {};
  dropdownList = [];
  selectedItems = [];
  selectedItemsForCreate = [];

  isUserEmployee: boolean = true;
  isExportToExcelBusy = false;

  filters = {} as GetTicketListDto;

  constructor(
    private datePipe: DatePipe,
    public readonly list: RouteListService,
    @Inject(SECONDARY_LIST) public readonly orgnUnitlist: ListService, //used so that this list would not impact the url and vice versa
    private formBuilder: UntypedFormBuilder,
    private taskService: TicketsService,
    private toaster: ToasterService,
    private localizationService: LocalizationService,
    public tenantDocumentLookupService: TenantDocumentLookupService,
    public tenantCourseLookupService: TenantCourseLookupService,
    public bundleLookupService: BundlesLookupService,
    private confirmation: ConfirmationService,
    private documentApprovalSettingsService: DocumentApprovalSettingsService,
    private config: ConfigStateService,
    private enovaOrganizationUnitLookupService: EnovaOrganizationUnitLookupService,
    private enovaOrganizationUnitService: EnovaOrganizationUnitsService,
    private router: Router,
    private permissionService: PermissionService,
    public testLookupService: TestLookupService
  )
  {
    this.tenantUsers$ = taskService.getTenantUserLookup(this.onlyActive).pipe(map(r => r.items));
    this.activeTenantUsers$ = taskService.getTenantUserLookup(true).pipe(map(r => r.items));
  }

  onSelectionFromValueChange(event: any) {
    this.selectedItemsForCreate = [];
    switch(event) {
      case "true":
        this.selectFromUsers = true;
        this.selectFromOrganizationUnit = false;
        break;
      case "false":
        this.selectFromUsers = false;
        this.selectFromOrganizationUnit = true;
        break;
      default: 
        this.selectFromUsers = false;
        this.selectFromOrganizationUnit = false;
        break;
    }
  }
  
  onOrganizationUnitSelect(item: any) {
    var data = this.filteredOrganizationUnits.items.find(x => x.displayName === item);
    this.selectedItems.push({name: data.displayName, id: data.id});
    this.getListWithFilters()
  }

  onOrganizationUnitCreateSelect(item: any) {
    var data = this.filteredOrganizationUnits.items.find(x => x.displayName === item);
    this.selectedItemsForCreate.push({name: data.displayName, id: data.id});
  }

  onOrganizationUnitDeSelect(item: any) {
    var data = this.selectedItems.find(x => x.displayName === item);
    var indexOfData = this.selectedItems.indexOf(data);
    this.selectedItems.splice(indexOfData, 1);
    this.getListWithFilters()
  }

  onOrganizationUnitCreateDeSelect(item: any) {
    var data = this.selectedItemsForCreate.find(x => x.displayName === item);
    var indexOfData = this.selectedItemsForCreate.indexOf(data);
    this.selectedItemsForCreate.splice(indexOfData, 1);
  }

  ngOnInit(): void {
    this.selectedUsers.items = [];
    this.selectedUsers.totalCount = 0;

    this.isCurrentUserEmployee();

    this.taskService.getTenantUserLookup(true).subscribe((response) => {
      this.tenantUsersLookup = response.items;
    });

    this.currentUserId = this.config.getOne("currentUser").id;

    this.documentApprovalSettingsService.getDocumentApprovalInformation(true).subscribe((response) => {
      this.responsibleUserForApproval = response;
    });
    
    this.selectedUsers.items = [];
    this.selectedUsers.totalCount = 0;

    this.taskService.getTenantUserLookup(true).subscribe((response) => {
      this.tenantUsersLookup = response.items;
    });

    const taskStreamCreator = (query) => this.taskService.getList(
      {
        ...query,
        ...this.filters,
        status: this.filterForm.get("taskStatus").value,
        ticketKind: this.filterForm.get("taskKind").value,
        ticketEducationKind: this.filterForm.get("taskEducationKind").value,
        assignedUserId: this.filterForm.get("assignedUserId").value,
        startDate: this.transformDate(this.filterForm.get("startDate").value, this.filterForm.get("startTime").value),
        endDate: this.transformDate(this.filterForm.get("endDate").value, this.filterForm.get("endTime").value),
        organizationUnitsIds: this.selectedItems ? this.selectedItems.map(item => item.id) : null,
        active: this.filterForm.get("onlyActive")?.value
      }
    );
    
    this.list.hookToQuery(taskStreamCreator).subscribe((response) => {
      this.task = response;
    });

    this.getOrganizationUnits();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      defaultOpen: false,
      enableCheckAll: false,
      noDataAvailablePlaceholderText: this.localizationService.instant("::NoDataAvailable"),
      searchPlaceholderText: this.localizationService.instant("::Search")
    };

    this.buildFormForSearch();
  }


  isBundleTicket(): boolean {
    const ticketKind = Number(this.createUpdateTicketForm.get('ticketKind').value);
    const educationKind = Number(this.createUpdateTicketForm.get('ticketEducationKind').value);
    
    return ticketKind === TicketKind.Education && educationKind === TicketEducationKind.Bundle;
  }

  isCurrentUserEmployee() {
    const currentUser = this.config.getOne("currentUser");

    const isEmployee = currentUser.roles.includes(UserRoleConsts.EMPLOYEE_ROLE);
    const isAdminOrDSSSpecialist = currentUser.roles.includes(UserRoleConsts.ADMIN_ROLE) || 
      currentUser.roles.includes(UserRoleConsts.DSS_SPECIALIST_ROLE);
    this.isUserEmployee = isEmployee && !isAdminOrDSSSpecialist;
  }

  organizationUnitFilterChange(event: any) {
    this.fetchOrganizationUnits({ filter: event } as LookupRequestDto);
  }

  getOrganizationUnits() {
    this.fetchOrganizationUnits({} as LookupRequestDto);
  }

  private fetchOrganizationUnits(requestDto: LookupRequestDto) {
    const orgUnitStreamCreator = (query) => {
      const updatedQuery = query.filter !== undefined ? { ...query, skipCount: 0, maxResultCount: 1000 }: { ...query, filter: requestDto.filter, skipCount: 0, maxResultCount: 1000 };
      return this.enovaOrganizationUnitLookupService.getOrganizationUnitLookup(updatedQuery);
    };
  
    this.orgnUnitlist.hookToQuery(orgUnitStreamCreator).subscribe((response) => {
      if (response && response.items && response.items.length > 0) {
        this.dropdownList = response.items.map(item => item.displayName);
      } else {
        this.dropdownList = [{
          item_id: 0,
          item_text: this.localizationService.instant("::NoDataAvailable"),
          isDisabled: true
        }];
      }
      
      if (response) {
        this.filteredOrganizationUnits = response;
      } else {
        this.filteredOrganizationUnits = {
          items: [],
          totalCount: 0
        };
      }
    });
  }

  searchTenantForTicket: OperatorFunction<string, readonly TenantUserLookupDto[]> = (text$: Observable<string>) => {
    const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
  
    return merge(debouncedText$, this.focusForTicketTenant$, this.clickForTicketTenant$).pipe(
      map(term => (term === '' ? this.tenantUsersLookup
        : this.tenantUsersLookup.filter(v => v.userName.toLowerCase().indexOf(term.toLowerCase()) > -1))
      )
    );
  };

  getSelectedTaskKind(kind) {
    this.createUpdateTicketForm.controls["document"].setValue(null);
    this.createUpdateTicketForm.controls["course"].setValue(null);
    this.createUpdateTicketForm.controls["bundle"].setValue(null);
    this.createUpdateTicketForm.controls["test"].setValue(null); 
    this.createUpdateTicketForm.controls["ticketEducationKind"].setValue(null);

    if (kind == TicketKind.Education) {
      this.isTicketEducationKindShown = true;
      this.isDocumentShown = null;
      this.isBundleShown = false;  
      this.isTestShown = false; 
      this.isDocumentShownForApproval = null;
      this.createUpdateTicketForm.controls["document"].setValidators(null);
      this.createUpdateTicketForm.controls["course"].setValidators(null);
      this.createUpdateTicketForm.controls["bundle"].setValidators(null); 
      this.createUpdateTicketForm.controls["test"].setValidators(null);

      this.createUpdateTicketForm.controls["ticketEducationKind"].setValidators([Validators.required]);
    } 
    else if (kind == TicketKind.Test) {
      this.isTicketEducationKindShown = false;
      this.isDocumentShown = null;
      this.isBundleShown = false;
      this.isTestShown = true;
      this.isDocumentShownForApproval = null;
      
      this.createUpdateTicketForm.controls["document"].setValidators(null);
      this.createUpdateTicketForm.controls["course"].setValidators(null);
      this.createUpdateTicketForm.controls["bundle"].setValidators(null);
      this.createUpdateTicketForm.controls["test"].setValidators([Validators.required]); 
      this.createUpdateTicketForm.controls["ticketEducationKind"].setValidators(null);
    }
    else if (kind == TicketKind.Renewal) { 
      this.isTicketEducationKindShown = false;
      this.isBundleShown = false; 
      this.isTestShown = false; 

      this.createUpdateTicketForm.controls["document"].setValidators(null);
      this.createUpdateTicketForm.controls["course"].setValidators(null);
      this.createUpdateTicketForm.controls["bundle"].setValidators(null); 
      this.createUpdateTicketForm.controls["test"].setValidators(null);
      
      this.createUpdateTicketForm.controls["ticketEducationKind"].setValidators(null);
    }
    else if (kind == TicketKind.DocumentApproval) {    
      if (this.responsibleUserForApproval == null) {
        this.createUpdateTicketForm.controls["ticketKind"].setValue(null);

        this.createUpdateTicketForm.controls["document"].updateValueAndValidity();
        this.createUpdateTicketForm.controls["course"].updateValueAndValidity();
        this.createUpdateTicketForm.controls["bundle"].updateValueAndValidity();
        this.createUpdateTicketForm.controls["ticketKind"].updateValueAndValidity();
        this.createUpdateTicketForm.controls["test"].updateValueAndValidity();

        this.toaster.warn(
          this.localizationService.instant("::TicketForApproval:Error:00001")
        );

        return;
      }

      this.isTicketEducationKindShown = true;
      this.isDocumentShown = null;
      this.isBundleShown = false;  
      this.isTestShown = false; 
      this.isDocumentShownForApproval = null;

      this.createUpdateTicketForm.controls["document"].setValidators(null);
      this.createUpdateTicketForm.controls["course"].setValidators(null);
      this.createUpdateTicketForm.controls["bundle"].setValidators(null); 
      this.createUpdateTicketForm.controls["test"].setValidators(null); 
      this.createUpdateTicketForm.controls["ticketEducationKind"].setValidators([Validators.required]);
      this.createUpdateTicketForm.controls["taskStatus"].setValue(TicketStatus.New);
      this.createUpdateTicketForm.controls["taskStatus"].updateValueAndValidity();
    }
    else if (kind == TicketKind.Ticket) {
      this.isTicketEducationKindShown = false;
      this.isDocumentShown = null;
      this.isBundleShown = false; 
      this.isTestShown = false; 
      this.isDocumentShownForApproval = null;

      this.createUpdateTicketForm.controls["document"].setValidators(null);
      this.createUpdateTicketForm.controls["course"].setValidators(null);
      this.createUpdateTicketForm.controls["bundle"].setValidators(null);
      this.createUpdateTicketForm.controls["test"].setValidators(null);
      this.createUpdateTicketForm.controls["ticketEducationKind"].setValidators(null);
    }
    else {
      this.isTicketEducationKindShown = false;
      this.isDocumentShown = null;
      this.isBundleShown = false; 
      this.isBundleShown = false; 
      this.isDocumentShownForApproval = null;

      this.createUpdateTicketForm.controls["document"].setValidators(null);
      this.createUpdateTicketForm.controls["course"].setValidators(null);
      this.createUpdateTicketForm.controls["bundle"].setValidators(null);
      this.createUpdateTicketForm.controls["test"].setValidators(null);
      this.createUpdateTicketForm.controls["ticketEducationKind"].setValidators(null);
    }

    this.isDocumentForApprovalSelectShown();

    this.createUpdateTicketForm.controls["document"].updateValueAndValidity();
    this.createUpdateTicketForm.controls["course"].updateValueAndValidity();
    this.createUpdateTicketForm.controls["bundle"].updateValueAndValidity();
    this.createUpdateTicketForm.controls["test"].updateValueAndValidity();
    this.createUpdateTicketForm.controls["ticketEducationKind"].updateValueAndValidity();
  }
  getAvailableEducationKinds() {
    if (this.isTicketForEdit()) {
      return this.ticketEducationKinds.filter(kind => kind.value !== TicketEducationKind.Bundle);
    }
    return this.ticketEducationKinds;
  }

  getSelectedTaskEducationKind(kind) {
    var ticketKind = this.createUpdateTicketForm.get('ticketKind').value;

    if (ticketKind == TicketKind.Education) {

      if (kind == TicketEducationKind.Course) {
        this.isDocumentShown = false;
        this.isBundleShown = false;

        this.createUpdateTicketForm.controls["document"].setValue(null);
        this.createUpdateTicketForm.controls["document"].setValidators(null);

        this.createUpdateTicketForm.controls["bundle"].setValue(null);
        this.createUpdateTicketForm.controls["bundle"].setValidators(null);

        this.createUpdateTicketForm.controls["course"].setValidators(Validators.required);
      }

      if (kind == TicketEducationKind.Document) {
        this.isDocumentShown = true;  
        this.isBundleShown = false;

        this.createUpdateTicketForm.controls["course"].setValue(null);
        this.createUpdateTicketForm.controls["course"].setValidators(null);

        this.createUpdateTicketForm.controls["bundle"].setValue(null);
        this.createUpdateTicketForm.controls["bundle"].setValidators(null);

        this.createUpdateTicketForm.controls["document"].setValidators(Validators.required);
      }
      
      if(kind == TicketEducationKind.Bundle) {
        this.isBundleShown = true;
        this.isDocumentShown = false;

        this.createUpdateTicketForm.controls["course"].setValue(null);
        this.createUpdateTicketForm.controls["course"].setValidators(null);

        this.createUpdateTicketForm.controls["document"].setValue(null);
        this.createUpdateTicketForm.controls["document"].setValidators(null);

        this.createUpdateTicketForm.controls["bundle"].setValidators(Validators.required);
      }

      if (kind === "") {
        this.isDocumentShown = null;
        this.isBundleShown = false;
      }   
    }
    
    if (ticketKind == TicketKind.DocumentApproval) {
      if (kind == TicketEducationKind.Course) {
        this.isDocumentShownForApproval = false;
        this.createUpdateTicketForm.controls["course"].setValidators([Validators.required]);
        this.createUpdateTicketForm.controls["document"].setValue(null);
        this.createUpdateTicketForm.controls["document"].setValidators(null);
      }

      if (kind == TicketEducationKind.Document) {
        this.isDocumentShownForApproval = true;      
        this.createUpdateTicketForm.controls["document"].setValidators([Validators.required]);
        this.createUpdateTicketForm.controls["course"].setValue(null);
        this.createUpdateTicketForm.controls["course"].setValidators(null);
      }

      if (kind === "") {
        this.isDocumentShownForApproval = null;
      }   
    }

    // ✅ Update all three controls
    this.createUpdateTicketForm.controls["document"].updateValueAndValidity();
    this.createUpdateTicketForm.controls["course"].updateValueAndValidity();
    this.createUpdateTicketForm.controls["bundle"].updateValueAndValidity();
  }
  isDocumentForApprovalSelectShown() {
    var value = this.createUpdateTicketForm.controls["ticketKind"].value;

    if (value == TicketKind.DocumentApproval) {
      this.createUpdateTicketForm.controls["taskStatus"].setValue(this.selectedTicket?.status != null ? this.selectedTicket.status : TicketStatus.New);
      this.createUpdateTicketForm.controls["assignedUserId"].setValue(this.responsibleUserForApproval?.selectedUser.id);

      this.selectedUsers.items = [{userName: this.responsibleUserForApproval?.selectedUser?.userName, id: this.responsibleUserForApproval?.selectedUser?.id}]
      this.selectedUsers.totalCount = 1;
      
      this.isTicketDocumentApprovalSelected = true;
      return true;
    }

    this.isTicketDocumentApprovalSelected = false;

    return false;
  }

  disableTicketStatusField(): boolean {
    if(!this.isTicketDocumentApprovalSelected){
      return false;
    }

    if(this.currentUserId == this.responsibleUserForApproval?.selectedUser.id){
      if( this.isTicketEdit && this.isTicketDocumentApprovalSelected ) 
      {
        return false;
      }
    }

    return true;
  }

  isDocumentSelectShown(){
    var value = this.createUpdateTicketForm.controls["ticketKind"].value;

    if(value == TicketKind.DocumentApproval || value == TicketKind.Ticket || value == null){
      return false;
    }

    if(this.isTicketEducationKindShown == false && !this.isTestShown) {
      return true;
    } else{
        if(this.isDocumentShown == true)
          return true;
        else 
          return false; 
    }
  }

  isCourseSelectShown() {
    var value = this.createUpdateTicketForm.controls["ticketKind"].value;

    if(value == TicketKind.DocumentApproval || value == TicketKind.Ticket || value == null)
      return false;

    if(this.isTicketEducationKindShown == false && !this.isTestShown) {
      return true;
    } else {
      if(this.isDocumentShown == false && !this.isBundleShown && !this.isTestShown)
        return true;
      else 
        return false;
    }
  }

  isBundleSelectShown() {
    var value = this.createUpdateTicketForm.controls["ticketKind"].value;

    if(value == TicketKind.DocumentApproval || value == TicketKind.Ticket || value == null)
      return false;

    if(this.isBundleShown){
      return true;
    }
    return false;
  }
  isTestSelectShown() {
    var value = this.createUpdateTicketForm.controls["ticketKind"].value;
    
    if(value == TicketKind.DocumentApproval || value == TicketKind.Ticket || value == null)
      return false;
    
    return this.isTestShown;
  }
  testHasRequiredValidator() {
    if(this.createUpdateTicketForm.controls["test"].hasValidator(Validators.required))
      return true;
    return false;
  }

  bundleHasRequiredValidator() {
    if(this.createUpdateTicketForm.controls["bundle"].hasValidator(Validators.required))
      return true;
    return false;
  }
  isCourseApproval() {
    if(this.createUpdateTicketForm.controls["course"].hasValidator(Validators.required) && this.isDocumentShownForApproval == false)
      return true;
    return false;
  }

  isDocumentApproval() {
    if(this.createUpdateTicketForm.controls["document"].hasValidator(Validators.required)  && this.isDocumentShownForApproval == true)
      return true;
    return false;
  }

  courseHasRequiredValidator(){
    if(this.createUpdateTicketForm.controls["course"].hasValidator(Validators.required))
      return true;
    return false;
  }

  documentHasRequiredValidator(){
    if(this.createUpdateTicketForm.controls["document"].hasValidator(Validators.required))
      return true;
    return false;
  }

  buildFormForSearch() {
    this.filterForm = this.formBuilder.group({
      startDate: [null],
      startTime: [{ hour: 0, minute: 0}],
      endDate: [null],
      endTime: [{ hour: 0, minute: 0}],
      assignedUserId: [null],
      taskStatus: [null],
      taskKind: [null],
      taskEducationKind: [null],
      document: [null],
      course: [null],
      organizationUnitId: [null],
      onlyActive: [true]
    });
  }

  isCurrentUserResponsible(): boolean {
    if(this.responsibleUserForApproval?.selectedUser.id == this.currentUserId) {
      return true;
    }

    return false;
  }

  buildFormForCreate() {
    this.selectedItemsForCreate = [];

    this.createUpdateTicketForm = this.formBuilder.group({
      name: [this.selectedTicket.name || this.localizationService.instant("::Ticket:Default:Name"), Validators.required],
      description: [this.selectedTicket.description || ''],
      assignedUserId: [this.selectedTicket.assignedUserId || null, Validators.required],
      taskStatus: [this.selectedTicket.status != null ? this.selectedTicket.status : TicketStatus.New, Validators.required],
      ticketKind: [this.selectedTicket.ticketKind != null ? this.selectedTicket.ticketKind : null, [Validators.required]],
      ticketEducationKind: [this.selectedTicket.ticketEducationKind != null ? this.selectedTicket.ticketEducationKind : null],
      course: [this.selectedTicket?.course?.id || null],
      document: [this.selectedTicket?.document?.id || null],
      bundle: [this.selectedTicket?.bundle?.id || null],
      test: [this.selectedTicket?.test?.id || null],
      startDate: [this.selectedTicket.startDateTime 
        ? new Date(this.selectedTicket.startDateTime) 
        : this.today, Validators.required
      ],
      startTime: [
        this.selectedTicket.startDateTime ? 
        { 
          hour: new Date(this.selectedTicket.startDateTime).getHours(),
          minute: new Date(this.selectedTicket.startDateTime).getMinutes()
        } :
        {
          hour: 12, 
          minute: 0
        }
      ],
      endDate: [this.selectedTicket.endDateTime 
        ? new Date(this.selectedTicket.endDateTime)
        : this.weekFromToday, Validators.required
      ],
      endTime: [
        this.selectedTicket.endDateTime ?
        { 
          hour: new Date(this.selectedTicket.endDateTime).getHours(), 
          minute: new Date(this.selectedTicket.endDateTime).getMinutes()
        } :
        {
          hour: 12,
          minute: 0
        }
      ],
      organizationUnitId: [null, []]
    });

    this.createUpdateTicketForm.get('ticketKind').valueChanges.subscribe((kind: TicketKind) => {
      this.getSelectedTaskKind(kind);
    });
  }
  getListWithFilters() {
    this.list.refreshToFirstPage()
  }

  onCheckBoxChange(){
    this.onlyActive = this.filterForm.get('onlyActive').value
    
    this.tenantUsers$ = this.taskService.getTenantUserLookup(this.onlyActive).pipe(map(r => r.items));

    this.getListWithFilters()
  }

  selectUsersFromSelectedOrganizationUnit() {
    var data = this.selectedItemsForCreate.length > 0 ? this.selectedItemsForCreate.map(e => e.id) : null;

    if (!data) {
      this.toaster.warn(
        this.localizationService.instant("::Organization:Unit:Selection:IsEmpty")
      );

      return;
    }

    this.enovaOrganizationUnitService.getUsers(data).subscribe((result) => {
      this.addUsersToList(result.items);
    });
    
  }

  transformDate(date: any, time: any) {
    if(date) {
      date.setHours(time?.hour != null ? time.hour : 0, time?.minute != null ? time.minute : 0, 0);
    }

    return this.datePipe.transform(date, "yyyy-MM-dd HH:mm");
  }
  
  clearFilters() {
    this.filterForm.reset();
    this.filterForm.patchValue({
      onlyActive: true
    })
    this.selectedItems = [];
    this.filters = {} as GetTicketListDto;
    this.onlyActive = this.filterForm.get('onlyActive')?.value
    this.tenantUsers$ = this.taskService.getTenantUserLookup(this.onlyActive).pipe(map(r => r.items));
    this.list.refreshToFirstPage();
  }

  createTicket() {
    this.selectedTicket = {} as TicketDto;
    this.selectedUsers.items = [];
    this.selectedUsers.totalCount = 0;
    this.isTicketEdit = false;
    this.isTicketEducationKindShown = false;
    this.selectFromUsers = false;
    this.selectFromOrganizationUnit = false;
    this.weekFromToday.setDate(this.today.getDate() + 7);
    this.buildFormForCreate();
    this.isDocumentForApprovalSelectShown();
    this.isModalOpen = true;
  }

  saveTicket() {
    if(this.createUpdateTicketForm.invalid){
      return;
    }
    if(this.isModalBusy){
      return;
    }
    this.isModalBusy = true
    
    if(this.selectedTicket.id){
      this.taskService.update(this.selectedTicket.id, this.formTicketForUpdateData()).subscribe({
        next: () => {
          this.isModalOpen = false;
          this.createUpdateTicketForm.reset();
          this.list.refreshCurrentPage();
        },
        complete: () => {
          this.toaster.success(
            this.localizationService.instant("::Ticket:Message:Edited:Success")
          );
          this.isModalBusy = false
        },
        error: () => {
          this.toaster.error(
            this.localizationService.instant("::Ticket:Message:Edited:Error")
          );
          this.isModalBusy = false
        }
      })
    } else {
      if(this.isBundleTicket()){
         this.taskService.createBundleTasks(this.formTicketData()).subscribe({
          next: (result) => {
            this.isModalOpen = false;
            this.list.refreshToFirstPage();
            this.createUpdateTicketForm.reset();
            
            // Show success message with bundle task details
            const successMessage = this.localizationService.instant("::Ticket:Bundle:Message:Created:Success");
            const detailsMessage = this.localizationService.instant("::Ticket:Bundle:Message:Details", 
              result.bundleName, result.estimatedTaskCount.toString(), result.assignedUsersCount.toString());
            
            this.toaster.success(
              successMessage + '\n' + detailsMessage + '\n\n' + result.message
            );
            this.isModalBusy = false
          },
          error: () => {
            this.toaster.error(
              this.localizationService.instant("::Ticket:Message:Created:Error")
            )
            this.isModalBusy = false
          }
        });
      }
      else{
        this.taskService.create(this.formTicketData()).subscribe({
          next: () => {
            this.isModalOpen = false;
            this.list.refreshToFirstPage();
            this.createUpdateTicketForm.reset();
          },
          complete: () => {
            this.toaster.success(
              this.localizationService.instant("::Ticket:Message:Created:Success")
            )
            this.isModalBusy = false
          },
          error: () => {
            this.toaster.error(
              this.localizationService.instant("::Ticket:Message:Created:Error")
            )
            this.isModalBusy = false
          }
        })
      }
    }
  }

  editTicket(ticketId: string) {
    this.isDocumentShown = null;
    this.isDocumentShownForApproval = null;
    this.selectedUsers.items = [];
    this.selectedUsers.totalCount = 0;
    this.isTicketEdit = true;
    this.taskService.get(ticketId).subscribe((ticket) => {
      this.selectedTicket = ticket;
      
      this.isTicketEducationKindShown = ticket.ticketKind == TicketKind.Education ? true : false;

      if(this.isTicketEducationKindShown){
        this.isDocumentShown = ticket.document != null ? true : (ticket.course != null ? false : null);
      }

      if(ticket.ticketKind == TicketKind.Test) {
        this.isTestShown = true;
        this.isDocumentShown = null;
        this.isBundleShown = false;
      }

      if(ticket.ticketKind == TicketKind.DocumentApproval) {
        if(ticket.document != null) {
          this.isDocumentShownForApproval = true;
          this.selectedTicket.ticketEducationKind = TicketEducationKind.Document;
        }

        if(ticket.course != null) {
          this.isDocumentShownForApproval = false;
          this.selectedTicket.ticketEducationKind = TicketEducationKind.Course;
        }

        this.selectedUsers.items = [{userName: this.selectedTicket.assignedUserName, id: this.selectedTicket.assignedUserId}]
        this.selectedUsers.totalCount = 1;
        
        this.isTicketDocumentApprovalSelected = true;
        this.isTicketEducationKindShown = true;
      }

      this.buildFormForCreate();
      
      if(ticket.ticketEducationKind != null) {
        this.getSelectedTaskEducationKind(ticket.ticketEducationKind);
      }

      if(this.isDocumentShown == true){
        this.createUpdateTicketForm.controls["document"].addValidators(Validators.required);
        this.createUpdateTicketForm.controls["document"].updateValueAndValidity();
      }
      if(this.isDocumentShown == false){
        this.createUpdateTicketForm.controls["course"].addValidators(Validators.required);
        this.createUpdateTicketForm.controls["course"].updateValueAndValidity();
      }
      this.isModalOpen = true;
    })
  }

  isTicketForEdit(): boolean {
    if(this.selectedTicket.id != null){
      return true
    }

    return false;
  }

  deleteTicket(ticketId: string) {
    this.confirmation.warn("::AreYouSureToDeleteTicket", "::AreYouSure").subscribe((status) => {
      if(status == Confirmation.Status.confirm){
        this.taskService.delete(ticketId).subscribe({
          next: () => this.list.refreshAfterDelete(this.task.totalCount!),
          complete: () => {
            this.toaster.success(
              this.localizationService.instant("::Ticket:Message:Deleted:Success")
            );
          },
          error: () => {
            this.toaster.error(
              this.localizationService.instant("::Ticket:Message:Deleted:Error")
            )
          }
        });
      }
    });
  }

  selectedNewTaskUsers(selectedUser: any) {
    if (selectedUser) {

      if(this.selectedUsers.totalCount > 0) {
        var isValuePresent = this.selectedUsers.items.find(x => x.userName == selectedUser.userName);
  
        if(isValuePresent) {
          this.toaster.error(
            this.localizationService.instant("::Ticket:Message:User:Error:00001")
          );
    
          return;
        }
      }

      this.selectedUsers.items.push({userName: selectedUser.userName, id: selectedUser.id});

      this.selectedUsers.items = [...this.selectedUsers.items]
      this.selectedUsers.totalCount++;

      this.checkIfSelectedUsers();
    }
  }

  addUsersToList(selectedUsers: TenantUserLookupDto[]) {
    if (selectedUsers) {
      if (this.selectedUsers.totalCount > 0) {
        selectedUsers.forEach(element => {
          var isValuePresent = this.selectedUsers.items.find(x => x.userName == element.userName);

          if (!isValuePresent) {
            this.selectedUsers.items.push({userName: element.userName, id: element.id});

            this.selectedUsers.items = [...this.selectedUsers.items]
            this.selectedUsers.totalCount++;
          }
        });
      } else {
        this.selectedUsers.items = selectedUsers;
        this.selectedUsers.totalCount = selectedUsers.length;
  
        this.selectedUsers.items = [...this.selectedUsers.items];
      }

      this.checkIfSelectedUsers();
    }
  }

  removeAssignedUser(eventValue: any) {
    this.selectedUsers.items.forEach((element, index) => {
      if(element.id == eventValue.id) {
        this.selectedUsers.items.splice(index, 1);
        this.selectedUsers.totalCount--;
        this.selectedUsers.items = [...this.selectedUsers.items];

        this.checkIfSelectedUsers();
      }
    });

  }

  checkIfSelectedUsers() {
    if(this.selectedUsers.totalCount == 0) {
      this.createUpdateTicketForm.controls["assignedUserId"].setValue(null);
      this.createUpdateTicketForm.controls["assignedUserId"].addValidators(Validators.required);
      this.createUpdateTicketForm.controls["assignedUserId"].updateValueAndValidity();
    } else {
      this.createUpdateTicketForm.controls["assignedUserId"].clearValidators();
      this.createUpdateTicketForm.controls["assignedUserId"].updateValueAndValidity();
    }
  }

  selectAllTenantUsers() { 
    this.taskService.getTenantUserLookup(true).subscribe((response) => {
      this.selectedUsers.items = response.items;
      this.selectedUsers.totalCount = response.items.length;

      this.checkIfSelectedUsers();
    })
  }

  formTicketData() {
    return {
      name: this.createUpdateTicketForm.get('name').value,
      description: this.createUpdateTicketForm.get('description').value,
      status: this.createUpdateTicketForm.get('taskStatus').value,
      ticketKind: this.createUpdateTicketForm.get('ticketKind').value,
      ticketEducationKind: this.createUpdateTicketForm.get('ticketEducationKind').value,
      assignedUserIdsList: this.selectedUsers.items.map(user => user.id),
      tenantCourseId: this.createUpdateTicketForm.get("course").value 
        ? this.createUpdateTicketForm.get("course").value : null,
      tenantDocumentId: this.createUpdateTicketForm.get("document").value 
        ? this.createUpdateTicketForm.get("document").value : null,
      bundleId: this.createUpdateTicketForm.get("bundle").value 
        ? this.createUpdateTicketForm.get("bundle").value : null,
      testId: this.createUpdateTicketForm.get("test").value 
        ? this.createUpdateTicketForm.get("test").value : null, // Add this line
      startDateTime: this.datePipe.transform(this.getStartTime(), "yyyy-MM-ddTHH:mm:ss"),
      endDateTime: this.datePipe.transform(this.getEndTime(), "yyyy-MM-ddTHH:mm:ss")
    }
  }


  formTicketForUpdateData() {
    return {
      name: this.createUpdateTicketForm.get('name').value,
      description: this.createUpdateTicketForm.get('description').value,
      status: this.createUpdateTicketForm.get('taskStatus').value,
      ticketKind: this.createUpdateTicketForm.get('ticketKind').value,
      ticketEducationKind: this.createUpdateTicketForm.get('ticketEducationKind').value,
      assignedUserId: this.createUpdateTicketForm.get('assignedUserId').value,
      tenantCourseId: this.createUpdateTicketForm.get("course").value 
        ? this.createUpdateTicketForm.get("course").value : null,
      tenantDocumentId: this.createUpdateTicketForm.get("document").value 
        ? this.createUpdateTicketForm.get("document").value : null,
      bundleId: this.createUpdateTicketForm.get("bundle").value 
        ? this.createUpdateTicketForm.get("bundle").value : null,
      testId: this.createUpdateTicketForm.get("test").value 
        ? this.createUpdateTicketForm.get("test").value : null, // Add this line
      startDateTime: this.datePipe.transform(this.getStartTime(), "yyyy-MM-ddTHH:mm:ss"),
      endDateTime: this.datePipe.transform(this.getEndTime(), "yyyy-MM-ddTHH:mm:ss")
    }
  }


  getStartTime() {
    let startDateTime = this.createUpdateTicketForm.get('startDate').value;
    startDateTime.setHours(this.createUpdateTicketForm.get('startTime').value.hour);
    startDateTime.setMinutes(this.createUpdateTicketForm.get('startTime').value.minute);
    return startDateTime
  }

  getEndTime() {
    let endDateTime = this.createUpdateTicketForm.get('endDate').value;
    endDateTime.setHours(this.createUpdateTicketForm.get('endTime').value.hour);
    endDateTime.setMinutes(this.createUpdateTicketForm.get('endTime').value.minute);
    return endDateTime
  }

  isDocumentAvailable(item: any): boolean {
    if (item.document != null 
      && this.permissionService.getGrantedPolicy('E-Document.Documents.View')) {
      return true;
    }
    return false;
  }

  isCourseAvailable(item: any): boolean {
    if (item.course != null && item.courseClassCount > 0
      && this.permissionService.getGrantedPolicy('Courses.Courses.View')) {
        return true;
    }
    return false;
  }

  isTestAvailable(item: any): boolean {
    if (item.test != null
      && this.config.getFeature("Test.Attempt") == "true") {
        return true;
    }
    return false;
  }
  isTicketAvailable(item: any): boolean {
    if(item.ticketKind == TicketKind.Ticket && this.permissionService.getGrantedPolicy('Tickets.Tickets.View')){
      return true;
    }
    return false;
  }
  navigateToAssignedDocument(item: any) {
    if (item.document != null) {
      this.router.navigate(['documents/view', item.document.id]);
    }
  }

  navigateToAssignedCourse(item: any) {
    if (item.course != null) {
      this.router.navigate(['courses/view', item.course.id])
    }
  }
  navigateToAssignedTicket(item: any) {
    if (item.ticketKind  == TicketKind.Ticket) {
      this.router.navigate(['tasks/view', item.id])
    }
  }
  navigateToAssignedTest(item: any) {
    if (item.test != null) {
        this.router.navigate(["test/attempt"], {queryParams: {
            id: item.test.id
        }});
    }
  }

  exportToExcel() {
    this.isExportToExcelBusy = true;
    this.taskService
      .getDownloadToken()
      .pipe(
        switchMap(({ token }) =>
          this.taskService.getListAsExcelFile({
            downloadToken: token,
            filter: this.filterForm.get('filter')?.value,
            taskStatus: this.filterForm.get('taskStatus')?.value,
            assignedUserId: this.filterForm.get('assignedUserId')?.value,
            taskKind: this.filterForm.get('taskKind')?.value,
            taskEducationKind: this.filterForm.get('taskEducationKind')?.value,
            tenantDocumentId: this.filters.tenantDocumentId,
            tenantCourseId: this.filters.tenantCourseId,
            startDate: this.transformDate(this.filterForm.get("startDate").value, this.filterForm.get("startTime").value),
            endDate: this.transformDate(this.filterForm.get("endDate").value, this.filterForm.get("endTime").value),
            organizationUnitId: this.selectedItems.map(x => x.id).join(','),
            active: this.filterForm.get("onlyActive")?.value
          })
        ),
        finalize(() => (this.isExportToExcelBusy = false))
      )
      .subscribe(result => {
        downloadBlob(result, 'Tickets.xlsx');
      });
  }
}
